<app-iota-modal [modalOptions]="modalOptions" (close$)="close()">
    <div modal-header class="flex flex-col gap-1">
        <h3 class="mb-0" i18n>Document</h3>
        <span *ngIf="documentName">{{ documentName }}</span>
    </div>
    <div modal-body class="flex flex-col">
        <div class="mb-5" *ngIf="!!data?.feedbackBanner && !feedbackBannerClosed">
            <app-feedback-banner
                [variant]="data?.feedbackBanner?.variant"
                [header]="data?.feedbackBanner?.header"
                [message]="data?.feedbackBanner?.message"
                [date]="data?.feedbackBanner?.date"
                [showCloseIcon]="data?.feedbackBanner?.showCloseIcon"
                (closeMessage)="closeFeedbackBanner()"
            ></app-feedback-banner>
        </div>
        <div class="flex flex-row justify-center">
            <embed
                *ngIf="(document$ | ngrxPush)?.url && !isImage()"
                class="w-full h-screen max-h-65vh"
                [src]="(document$ | ngrxPush).url"
            />
            <img *ngIf="isImage()" class="max-w-full max-h-65vh rounded-lg" [src]="(document$ | ngrxPush).url" />

            <input id="fileInputInDialog" hidden type="file" (change)="selectFile($event)" />´
        </div>
    </div>

    <div modal-footer class="flex grow justify-between">
        <div class="flex-1"></div>
        <button class="btn btn-primary" (click)="download()" i18n>Download</button>
        <button *ngIf="data.showUploadButton" class="btn btn-primary" (click)="openInput()" i18n>Upload</button>
    </div>
</app-iota-modal>
